module.exports = __webpack_public_path__ + "img/UlnarWristPain.0a83c862.svg";